export default __webpack_public_path__ + "static/media/slide1.b1531644.png";